import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import { location, province } from "../../../../api";
import NormalInput from "../../../../components/form/HorizontalNormalInput";
import { Card, CardBody, CardHeader } from "../../../../components/card/card";
import Select from "react-select";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0, 0, 0, 0.48)",
    borderColor: "var(--bs-border-color)",
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "white",
  }),
};

function ModalChangePlant({
  openModal,
  setOpenModal,
  onSuccess,
  selected,
  selectedIndex,
  parentLocations,
  title,
  onSubmitted,
  editMode,
}) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedParentLocation, setSelectedParentLocation] = useState(null);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const { config } = useAuth();
  const location_wording = config.location_wording.split(",");
  const [dataToSend, setDataToSend] = useState({
    location_name: "",
    picture_url: "",
    location_address: "",
    contact_person: "",
    contact_number: "",
    contact_email: "",
    parent_location_id: "",
    province_id: "",
    lat: "",
    lng: "",
  });
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  async function getProvinces() {
    try {
      const res = await province.list({ page: 1, take: 1000 });
      if (res.ok) {
        const body = await res.json();
        const options = (body.data?.results || []).map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setProvinces(options);
        return options;
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
    return [];
  }

  async function getRecord() {
    const provinceOptions = provinces.length ? provinces : await getProvinces();
    if (selected) {
      setPreview(renderImage(`/machine/attachment/${selected.picture_url}`));
      setDataToSend((prevData) => ({
        ...prevData,
        location_name: selected.location_name,
        picture_url: selected.picture_url,
        location_address: selected.location_address || "",
        contact_person: selected.contact_person || "",
        contact_number: selected.contact_number || "",
        contact_email: selected.contact_email || "",
        province_id: selected.province_id || "",
        lat: selected.lat || "",
        lng: selected.lng || "",
      }));
      setSelectedParentLocation(
        parentLocations.find(
          (parent) => parent.value === selected.parent_location_id
        )
      );
      setSelectedProvince(
        provinceOptions.find((item) => item.value === selected.province_id) ||
          null
      );
    } else {
      setPreview("");
      setDataToSend((prevData) => ({
        ...prevData,
        location_name: "",
        picture_url: "",
        location_address: "",
        contact_person: "",
        contact_number: "",
        contact_email: "",
        province_id: "",
        lat: "",
        lng: "",
      }));
      setSelectedParentLocation(null);
      setSelectedProvince(null);
    }
  }

  useEffect(() => {
    getProvinces();
  }, []);

  useEffect(() => {
    console.log("selected", selected);
    getRecord();
  }, [selected]);

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);
  const onSelectFile = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }
    setSelectedFile(e.target.files[0]);
  };

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleEdit = async () => {
    try {
      setLoading(true);
      let hasil = dataToSend;
      hasil.parent_location_id = selectedParentLocation?.value || "";
      hasil.province_id = selectedProvince?.value || "";

      if (selectedIndex > 0 && !hasil.parent_location_id) {
        toast.error("Please complete all mandatory field");
        return;
      }

      hasil.location_id = selected.id;
      hasil.contact_number = hasil.contact_number?.toString();
      delete hasil.parent_id;
      //console.log({ selected });
      const res = await location.update(selected.id, hasil, selectedFile);

      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          onSubmitted();
          setOpenModal(false);
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  const clearFields = () => {
    setDataToSend({
      location_name: "",
      picture_url: "",
      location_address: "",
      parent_location_id: "",
      province_id: "",
      contact_person: "",
      contact_number: "",
      contact_email: "",
      lat: "",
      lng: "",
    });
    setPreview("");
    setSelectedFile(null);
    setSelectedParentLocation(null);
    setSelectedProvince(null);
  };
  const handleSubmit = async () => {
    try {
      let hasil = dataToSend;
      hasil.parent_location_id = selectedParentLocation?.value || "";
      hasil.province_id = selectedProvince?.value || "";

      if (!hasil.location_name || !hasil.location_address) {
        toast.error("Please complete all mandatory field");
        return;
      }
      if (selectedIndex > 0 && !hasil.parent_location_id) {
        toast.error("Please complete all mandatory field");
        return;
      }

      setLoading(true);
      delete hasil.parent_id;
      hasil.contact_number = hasil.contact_number?.toString();
      const res = await location.create(hasil, selectedFile);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          onSubmitted();
          setOpenModal(false);
          clearFields();
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <ConfirmationDlg
      open={openModal}
      size={"lg"}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={editMode ? handleEdit : handleSubmit}
      onClose={handleClose}
      loading={loading}
    >
      <h4>{location_wording[selectedIndex]}</h4>
      <div className="my-2">
        <div className="row">
          <div className="col-md-4 position-relative">
            <Card>
              <CardHeader>Photo</CardHeader>
              <CardBody>
                <label htmlFor="files">
                  {preview ? (
                    <>
                      <img src={preview} className="img-thumbnail" alt="" />
                      <div
                        style={{
                          textAlign: "center",
                          cursor: "pointer",
                          marginTop: "5px",
                        }}
                      >
                        Change Photo <i className="fa fa-camera"></i>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          minHeight: "150px",
                          alignItems: "center",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <i className="fa fa-camera"></i>
                        <div>Add a Photo</div>
                      </div>
                    </>
                  )}
                </label>
                <input
                  id="files"
                  onChange={onSelectFile}
                  style={{ visibility: "hidden", position: "absolute" }}
                  type="file"
                  accept="image/png, image/jpeg"
                />
              </CardBody>
            </Card>
          </div>
          <div className="col-md-8">
            <NormalInput
              full={true}
              required={true}
              placeholder={`Enter ${location_wording[selectedIndex]} Name`}
              value={dataToSend["location_name"]}
              label={location_wording[selectedIndex]}
              onchange={handleOnchange}
              name="location_name"
            />

            {selectedIndex > 0 && (
              <div className="mb-3">
                <label className="form-label">
                  {location_wording[selectedIndex - 1]}{" "}
                  <span className="text-danger">*</span>
                </label>
                <Select
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isClearable={true}
                  placeholder={`- Select ${
                    location_wording[selectedIndex - 1]
                  } -`}
                  isSearchable={true}
                  styles={colourStyles}
                  options={parentLocations}
                  value={selectedParentLocation}
                  onChange={setSelectedParentLocation}
                />
              </div>
            )}

            <div className="mb-3">
              <label className="form-label">Province</label>
              <Select
                isMulti={false}
                closeMenuOnSelect={true}
                isClearable={true}
                placeholder="- Select Province -"
                isSearchable={true}
                styles={colourStyles}
                options={provinces}
                value={selectedProvince}
                onChange={setSelectedProvince}
              />
            </div>

            <NormalInput
              full={true}
              required={true}
              placeholder={`Enter ${location_wording[selectedIndex]} Address`}
              value={dataToSend["location_address"]}
              label="Address"
              onchange={handleOnchange}
              name="location_address"
            />

            <NormalInput
              full={true}
              required={false}
              placeholder={"Enter Name of Contact Person"}
              value={dataToSend["contact_person"]}
              label="Contact Person"
              onchange={handleOnchange}
              name="contact_person"
            />

            <NormalInput
              full={true}
              required={false}
              placeholder={"Enter Contact Number"}
              value={dataToSend["contact_number"]}
              label="Contact Number"
              onchange={handleOnchange}
              name="contact_number"
            />
            <NormalInput
              full={true}
              required={false}
              placeholder={"Enter Email"}
              value={dataToSend["contact_email"]}
              label="Email"
              onchange={handleOnchange}
              name="contact_email"
            />

            <NormalInput
              full={true}
              required={false}
              placeholder={"Enter Latitude"}
              value={dataToSend["lat"]}
              label="Latitude"
              onchange={handleOnchange}
              name="lat"
              type="number"
            />
            <NormalInput
              full={true}
              required={false}
              placeholder={"Enter Longitude"}
              value={dataToSend["lng"]}
              label="Longitude"
              onchange={handleOnchange}
              name="lng"
              type="number"
            />
          </div>
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangePlant;
